// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1142":"921ecefd29211595","2013":"dd3674db48807f46","2997":"12a54815cc4ced5a","6005":"03abfccbd4e840ce","7242":"8b5fc26fa3f1b61b"}[chunkId] + ".css";
};